import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  useApi,
  useSession
} from '~components'

/**
 * Component to manage payment option stripe behavior without UI component
 */
export const PaymentOptionPowerTranz = (props) => {
  const {
    businessId,
    UIComponent,
    publicKey
  } = props

  const [{ token, user }] = useSession()

  const [ordering] = useApi()
  const [addCartOpen2, setAddCardOpen2] = useState(false)
  const [addCartOpen, setAddCardOpen] = useState(false)
  /**
   * Contains and object to save cards, handle loading and error
   */
  const [cardsList, setCardsList] = useState({ cards: [], loading: true, error: null })
  /**
   * save stripe public key
   */

  const [cardSelected, setCardSelected] = useState(null)
  const [cardDefault, setCardDefault] = useState(null)
  const [defaultCardSetActionStatus, setDefaultCardSetActionStatus] = useState({ loading: false, error: null })

  const [facCardData, setfacCardData] = useState({
    card_holder: '',
    card_number: '',
    exp_month: '',
    exp_year: '',
    card_cvv: '',
    err_msg: '',
    save_for_future: false
  })
  const handleChangeFacCardName = () => {
    setfacCardData({
      ...facCardData,
      card_holder: document.getElementById('card_holder').value,
      err_msg: ''
    })
  }
  const handleChangeFacCard = () => {
    setfacCardData({
      ...facCardData,
      card_number: document.getElementById('card_number').value,
      err_msg: ''
    })
  }
  const handleChangeFacMonth = () => {
    setfacCardData({
      ...facCardData,
      exp_month: document.getElementById('exp_month').value,
      err_msg: ''
    })
  }
  const handleChangeFacYear = () => {
    setfacCardData({
      ...facCardData,
      exp_year: document.getElementById('exp_year').value,
      err_msg: ''
    })
  }
  const handleChangeFacCvv = () => {
    setfacCardData({
      ...facCardData,
      card_cvv: document.getElementById('card_cvv').value,
      err_msg: ''
    })
  }
  /**
   * method to get cards from API
   */

  const getCredentials = async () => {
    const requestOptions = {
      method: 'GET'
    }
    const functionFetch = 'https://plugins-development.ordering.co/power_tranz_v2/api/get_cards.php?user_id=' + user.id + '&project_name=yaak'
    const response = await fetch(functionFetch, requestOptions)
    const content = await response.json()
    const newCards = []
    if (!content?.error) {
      setCardsList({
        ...cardsList,
        loading: false,
        cards: content?.result
      })
    } else {
      setCardsList({
        ...cardsList,
        loading: false,
        cards: newCards
      })
    }
  }
  /**
   * method to get cards from API
   */
  const deleteCard = async (card) => {
    try {
      // The order of paymentCards params is businessId, userId, cardId. This sdk needs to be improved in the future,
      const { content: { error } } = await ordering.paymentCards(-1, user.id, card.id).delete()
      if (!error) {
        cardsList.cards = cardsList.cards.filter(_card => _card.id !== card.id)
        setCardsList({
          ...cardsList
        })
      }
    } catch (error) {
      console.error(error.message)
    }
  }
  /**
   * method to set card as default
   */
  const setDefaultCard = async (card) => {
    try {
      setDefaultCardSetActionStatus({ ...defaultCardSetActionStatus, loading: true })
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          business_id: businessId,
          user_id: user.id,
          card_id: card.id
        })
      }
      const functionFetch = `${ordering.root}/payments/stripe/cards/default`
      const response = await fetch(functionFetch, requestOptions)
      const content = await response.json()
      if (!content.error) {
        setCardDefault({
          id: '1',
          type: 'card',
          card: {
            brand: card.brand,
            last4: card.last4
          }
        })
        setDefaultCardSetActionStatus({ loading: false, error: null })
      } else {
        setDefaultCardSetActionStatus({ loading: false, error: content.result })
      }
    } catch (error) {
      setDefaultCardSetActionStatus({ loading: false, error })
    }
  }

  const handleCardClick = (card) => {
    console.log(card)
    window.localStorage.setItem('facNewCard', 'no')
    setCardSelected({
      token: card.customerDatalast4,
      type: 'card',
      card_id: card.id,
      card: {
        brand: card.id,
        last4: card.customerDatalast4
      }
    })
  }

  const handleNewCard = (card) => {
    cardsList.cards.push(card)
    setCardsList({
      ...cardsList
    })
    handleCardClick(card)
  }

  useEffect(() => {
    getCredentials()
  }, [])

  const handlePay = async (saveForFuture = false) => {
    console.log('add card ')
    console.log('saveForFuture:', saveForFuture)
    if (facCardData.card_holder === '') {
      setfacCardData({ ...facCardData, err_msg: 'Please Enter card Holder Name' })
    } else if (facCardData.card_number === '') {
      setfacCardData({ ...facCardData, err_msg: 'Please Enter card details' })
    } else if (facCardData.exp_month.length < 2 || parseInt(facCardData.exp_month) > 12) {
      setfacCardData({ ...facCardData, err_msg: 'Please Enter Expiry Month(MM)' })
    } else if (facCardData.exp_year.length < 2) {
      setfacCardData({ ...facCardData, err_msg: 'Please Enter Expiry Year(YY)' })
    } else if (facCardData.card_cvv === '') {
      setfacCardData({ ...facCardData, err_msg: 'Please Enter CVV number' })
    } else {
      // Create updated card data with save_for_future value
      const updatedCardData = { ...facCardData, save_for_future: saveForFuture }

      // Update state
      setfacCardData(updatedCardData)

      // Store in localStorage immediately with the updated value
      window.localStorage.setItem('facCardData', JSON.stringify(updatedCardData))
      window.localStorage.setItem('saveCardForFuture', saveForFuture ? 'yes' : 'no')
      window.localStorage.setItem('facNewCard', 'yes')

      setAddCardOpen2(true)
    }
  }

  const redSysDeleteCardnew = async (card) => {
    try {
      const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
          userid: user.id,
          card: card.id
        })
      }
      const functionFetch = `https://plugins-development.ordering.co/power_tranz_v2/api/delete_card.php?project_name=yaak&user_id=${user.id}&card_id=${card.id}`
      const response = await fetch(functionFetch, requestOptions)
      const content = await response.json()
      console.log(content)
      const newCards = []
      const extngCardList = cardsList.cards
      if (extngCardList.length > 0) {
        for (const i in cardsList.cards) {
          if (cardsList.cards[i].id !== card.id) {
            newCards.push(cardsList.cards[i])
          }
        }
        setCardsList({
          ...cardsList,
          loading: false,
          cards: newCards
        })
      } else {
        setCardsList({
          ...cardsList,
          loading: false,
          cards: newCards
        })
      }
    } catch (error) {
    }
  }

  const setAddCardOpenfnc = (status) => {
    setAddCardOpen2(false)
    setAddCardOpen(status)
  }

  return (
    <>
      {UIComponent && (
        <UIComponent
          {...props}
          cardSelected={cardSelected}
          cardDefault={cardDefault}
          cardsList={cardsList}
          handleCardClick={handleCardClick}
          publicKey={publicKey}
          handleNewCard={handleNewCard}
          deleteCard={deleteCard}
          setDefaultCard={setDefaultCard}
          defaultCardSetActionStatus={defaultCardSetActionStatus}
          handlePay={handlePay}
          handleChangeFacCardName={handleChangeFacCardName}
          handleChangeFacCard={handleChangeFacCard}
          handleChangeFacMonth={handleChangeFacMonth}
          handleChangeFacYear={handleChangeFacYear}
          handleChangeFacCvv={handleChangeFacCvv}
          facCardData={facCardData}
          addCartOpen2={addCartOpen2}
          redSysDeleteCardnew={redSysDeleteCardnew}
          setAddCardOpenfnc={setAddCardOpenfnc}
          addCartOpen={addCartOpen}
        />
      )}
    </>
  )
}

PaymentOptionPowerTranz.propTypes = {
  /**
   * UI Component, this must be containt all graphic elements and use parent props
   */
  UIComponent: PropTypes.elementType,
  /**
   * Business id to get cards from API
   */
  businessId: PropTypes.number.isRequired,
  /**
   * User id to pass in endpoint to get cards from API,
   */
  userId: PropTypes.number,
  /**
   * Components types before payment option stripe
   * Array of type components, the parent props will pass to these components
   */
  beforeComponents: PropTypes.arrayOf(PropTypes.elementType),
  /**
   * Components types after payment option stripe
   * Array of type components, the parent props will pass to these components
   */
  afterComponents: PropTypes.arrayOf(PropTypes.elementType),
  /**
   * Elements before payment option stripe
   * Array of HTML/Components elements, these components will not get the parent props
   */
  beforeElements: PropTypes.arrayOf(PropTypes.element),
  /**
   * Elements after payment option stripe
   * Array of HTML/Components elements, these components will not get the parent props
   */
  afterElements: PropTypes.arrayOf(PropTypes.element)
}

PaymentOptionPowerTranz.defaultProps = {
  beforeComponents: [],
  afterComponents: [],
  beforeElements: [],
  afterElements: []
}
